import { render, staticRenderFns } from "./icyIphone.vue?vue&type=template&id=02552f8c&scoped=true&"
import script from "./icyIphone.vue?vue&type=script&lang=js&"
export * from "./icyIphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02552f8c",
  null
  
)

export default component.exports